const userRoles = {
	Admin: 'Admin',
	CustomerRepresentative: 'CustomerRepresentative',
};

const userRoleLabels = {
	[userRoles.Admin]: 'Tenant Admin',
	[userRoles.CustomerRepresentative]: 'Tenant Customer Rep',
};

export default userRoles;
export { userRoleLabels };
